export enum ContactRequestTypeEnum {
  UNKNOWN = "unknown",
  SALES = "sales",
  SUPPORT = "support",
}
